import { ProFormaModelIds } from 'constants/proForma';
import { IDealSelection } from './types';

export const isMixedLandDevelopmentSelection = (selections: IDealSelection[]): boolean => {
    const modelIds = selections
        .map(selection => selection.proFormaModelId)
        .filter((modelId): modelId is number => modelId != null);

    const hasLandDevelopment = modelIds.some(modelId => modelId === ProFormaModelIds.LAND_DEVELOPMENT);
    const hasNonLandDevelopment = modelIds.some(modelId => modelId !== ProFormaModelIds.LAND_DEVELOPMENT);

    return hasLandDevelopment && hasNonLandDevelopment;
};

export const isAllLandDevelopmentSelection = (selections: IDealSelection[]): boolean =>
    selections.length > 0 && selections.every(selection => selection.proFormaModelId === ProFormaModelIds.LAND_DEVELOPMENT);
